import React, { useContext, useEffect, useRef, useState } from 'react';
import { COMPONENT_TYPES } from '../../config/constants';
import { EVENT, KEYS } from '../../contexts/MixpanelConstants';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import h, { getCountry } from '../../helpers/common';
import f from '../../helpers/formatter';
import f2 from '../../helpers/formatter2';
import { Carousel2 } from '@intigral/ui/components/Carousel2';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { __ } from '../../translations';
import { PaginationProps } from '@intigral/shared/components/Pagination';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import useLanguage from '../../hooks/useLanguage';
import VodItem from '../elements/VodItem';
interface VodCarouselProps {
    content?: any[];
    name?: string;
    meta?: {
        title?: Languages;
    };
    params?: any;
    data_stream?: string;
    MoodChangeElement?: PaginationProps;
    onItemClick?: (item: any, index: any) => void;
    id?: string;
    carousel?: Carousel;
    componentType?: string;
}
interface Languages {
    ar?: string;
    en?: string;
}

export const VodCarousel: React.FC<VodCarouselProps> = (props) => {
    //  This section is only for Div vod carousel ,
    //  if Guid is not present for promotions and need to show Div contents,then getting guid from all assets/series apis and pass it div apis.
    const [content, setContent] = useState<any[]>(Array.isArray(props.content) ? props.content : []);
    const [lastWatchedMovieTitle, setLastWatchedMovieTitle] = useState<string>('');
    const { MoodChangeElement = null, onItemClick = undefined } = props;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { track } = useContext(MixpanelContext) || { track: () => {} };

    useEffect(() => {
        setContent(props?.content != null ? props?.content : []);
    }, [props.content]);

    const sliderElement = useRef<HTMLDivElement>(null);
    const componentId = props.id ? props.id : '';
    const componentType = props.componentType ?? COMPONENT_TYPES.VOD_CAROUSEL;
    const language = useLanguage();

    const handleSeeAllLinkClick = (item) => {
        const eventProps = {
            [KEYS.CAROUSEL.SCREEN_NAME]: h.getScreen(),
            [KEYS.CAROUSEL.CAROUSEL_NAME]: props.name,
            [KEYS.CAROUSEL.CAROUSEL_TYPE]: h.getCarouselComponentType(COMPONENT_TYPES.VOD_CAROUSEL),
        };
        track(`${h.getScreen()} - ${EVENT.CAROUSEL.SEE_ALL}`, eventProps);
    };

    const countryCode = getCountry().toLowerCase();
    const countryName = __(`country_${countryCode}`);

    const placeHoldersValues = {};
    placeHoldersValues[`country`] = countryName;

    const componentTitle = `${f.getComponentTitle(props.meta)} ${lastWatchedMovieTitle}`;
    const formattedTitle = f2.getPlaceholderValue(componentTitle, { country: countryName });
    // unique class name to address the swiper pagination
    const pagingId = `component-${Math.random().toString(36).slice(2, 11)}`;
    const paginationClass = `pagination-${pagingId}`;

    const activeItemsCount = content.filter((item) => !(h.hasTVODTag(item) && !h.isTVODEnabled())).length;

    return (
        <div className="container full-width" ref={sliderElement} id={componentId} data-test-id={props?.carousel?.id}>
            <SectionHeaderWithPagination
                title={formattedTitle}
                className={`${paginationClass} `}
                seeAllUrl={
                    MoodChangeElement
                        ? MoodChangeElement?.seeAllUrl
                        : (f.getComponentSeeAllLink(props.meta, props.params, props.data_stream) as string)
                }
                seeAllText={MoodChangeElement ? MoodChangeElement?.seeAllText : __('home_carousel_see_all')}
                onClick={MoodChangeElement ? MoodChangeElement?.onClick : () => handleSeeAllLinkClick(props.meta)}
            />

            <Carousel2
                swiperSettings={{
                    autoplay: false,
                    loop: false,
                    dir: language == 'ar' ? 'rtl' : 'ltr',
                    pagination: {
                        el: `.${paginationClass}`,
                        clickable: true,
                    },
                }}
                dir={language == 'ar' ? 'rtl' : 'ltr'}
            >
                {content.map((item, index) => {
                    const enhancedMeta = Object.assign({}, props.meta);
                    return (
                        <VodItem
                            key={item.paId}
                            index={index}
                            item={item}
                            meta={enhancedMeta}
                            componentType={componentType}
                            componentName={props.name}
                            type={props?.carousel?.type}
                            onItemClick={onItemClick}
                        />
                    );
                })}
            </Carousel2>
        </div>
    );
};
